<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <circle fill="#ffffff" cx="256" cy="256" r="256" />
</svg>
